import DrawFlow from 'drawflow'

export default class DrawFlowExtended extends DrawFlow {
  constructor(container, render = null, parent = null) {
    super(container, render, parent)
  }

  removeNodeId(id) {
    this.removeConnectionNodeId(id)
    var moduleName = this.getModuleFromNodeId(id.slice(5))
    if (this.module === moduleName) {
      this.container.querySelector(`#${id}`).remove()
    }
    const removedNode = this.drawflow.drawflow[moduleName].data[id.slice(5)]
    delete this.drawflow.drawflow[moduleName].data[id.slice(5)]
    this.dispatch('nodeRemoved', removedNode)
  }
}
